import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserService } from 'src/app/services/user-service/user.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Subscription } from 'rxjs/internal/Subscription';
import sha256 from 'crypto-js/sha256';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-password-recovery-card',
  templateUrl: './password-recovery-card.component.html',
  styleUrls: ['./password-recovery-card.component.scss']
})
export class PasswordRecoveryCardComponent implements OnInit {

  errorMessage: string;
  tokenErrorMessage: string;
  successMessage: string;
  verifyPassSubscription: Subscription;
  passwordChanged: boolean;
  basicDataForm = new FormGroup({
    password: new FormControl(null, Validators.required),
    confirmPassword: new FormControl(null, Validators.required)
  });

  constructor(private userService: UserService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private userStorageService: UserStorageService) {
                this.passwordChanged = false;
              }

  ngOnInit() { }

  public verifyPass() {
    this.errorMessage = '';
    this.successMessage = '';
    const recoveryToken = this.activatedRoute.snapshot.params['recoveryToken'];
    const hashedPassword = sha256(this.basicDataForm.get('password').value).toString().toUpperCase();
    const validation = this.validateForm();
    if (validation === true) {
      this.verifyPassSubscription = this.userService.verifyPass(this.userStorageService.getLang(), this.userStorageService.getUDID(), recoveryToken, hashedPassword).subscribe(
        (res) => {
          this.successMessage = 'signin-page.snackbar messages.password changed';
          this.passwordChanged = true;
        },
        (error) => {
          this.tokenErrorMessage = 'signin-page.snackbar messages.wrong token';
          this.passwordChanged = true;
        }
      );
    } else {
      this.passwordChanged = false;
      this.errorMessage = validation;
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('password').valid || !this.basicDataForm.get('confirmPassword').valid) {
      return 'signin-page.snackbar messages.empty password';
    } else  if (this.basicDataForm.get('password').value !== this.basicDataForm.get('confirmPassword').value) {
      return 'signin-page.snackbar messages.password mismatch';
    } else {
      return true;
    }
  }

  public gotoLogin() {
    this.router.navigate(['/']);
  }
}
